import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import FilterOptions from '../OrderFlowCard/OrderFlow/FilterOptions';
import ChannelsAutocomplete from '../OrderFlowCard/OrderFlow/FilterOptions/ChannelsAutocomplete';
import OrderSummaries from '../OrderFlowCard/OrderFlow/OrderSummaries';
import {
  ChannelSelectionProps,
  selectChannelOptions,
  setChannels,
} from '../../../../slices/orders/channelsSlice';
import { useAppDispatch, useAppSelector } from '../../../../hooks';

export default function OrderFlowCard() {
  const dispatch = useAppDispatch();
  const channels = useAppSelector(selectChannelOptions);

  const handleChannelChange = (newValue: ChannelSelectionProps[] | null) => {
    dispatch(setChannels(newValue));
  };

  return (
    <Card raised>
      <CardHeader
        title="Order Flow - Last 24 hours"
        subheader={
          <ChannelsAutocomplete
            value={channels}
            handleValueChange={handleChannelChange}
            label="Channel(s) - optional"
          />
        }
        action={<FilterOptions />}
        titleTypographyProps={{ color: 'error', fontSize: 20 }}
        subheaderTypographyProps={{ mt: 1 }}
        sx={{ pb: 0, pt: 1.5 }}
      />
      <CardContent
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          pt: 1,
          pl: 1.5,
          pr: 1.5,
          '&:last-child': { pb: 1.5 },
        }}
      >
        <React.Suspense fallback={<CircularProgress />}>
          <OrderSummaries />
        </React.Suspense>
      </CardContent>
    </Card>
  );
}
